module.exports = __webpack_public_path__ + "img/edge_restauration_fromage.eb55d4f8.svg";